import { Fragment } from "react";
import InfoLabel, { InfoLabelProps } from "./InfoLabel";
import Icon from "../Icon";
import { formatCurrency, Currency, getClasses } from "../../utils";
import { BalanceType } from "../../commander/Types";
import classes from "../../styles/InfoLabel.module.css";
import { useTranslation } from "../../hooks";

type BalanceLabelProps = InfoLabelProps & {
  currency: Currency;
  insignia?: "text" | "icon";
  balance: { value: string; net: string; type: BalanceType };
};

const NetBalance: React.FC<BalanceLabelProps> = ({ balance, currency }) => {
  if (balance.type !== "full") return null;

  const net = parseFloat(balance.net as string);
  let sign;
  let colorClass;
  if (net < 0) {
    sign = "-";
    colorClass = "color text-danger";
  } else if (net > 0) {
    sign = "+";
    colorClass = "color text-success";
  } else {
    sign = "";
    colorClass = "color text-white";
  }

  return (
    <Fragment>
      <span className={getClasses(classes, "net-separator", colorClass)}>
        |
      </span>
      <span className={getClasses(classes, "net-balance", colorClass)}>
        {sign}
        {formatCurrency(Math.abs(net), currency)}
      </span>
    </Fragment>
  );
};

const BalanceLabel: React.FC<BalanceLabelProps> = (props) => {
  const { visible, direction, balance, shape, currency, insignia } = props;
  const balanceText = useTranslation("balance");

  const balaneInsignia =
    insignia === "icon" ? (
      <Icon type="Balance" size={25} />
    ) : (
      <div>{balanceText}:</div>
    );

  return (
    <InfoLabel shape={shape} direction={direction} visible={visible}>
      {balaneInsignia}
      <div className="color text-accent currency">
        {formatCurrency(balance.value, currency)}
        <NetBalance balance={balance} currency={currency} />
      </div>
    </InfoLabel>
  );
};

export default BalanceLabel;
